import { render, staticRenderFns } from "./subCategories.vue?vue&type=template&id=676641fe&scoped=true&"
import script from "./subCategories.vue?vue&type=script&lang=js&"
export * from "./subCategories.vue?vue&type=script&lang=js&"
import style0 from "./subCategories.vue?vue&type=style&index=0&id=676641fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676641fe",
  null
  
)

export default component.exports